import { lightFormat, parse } from 'date-fns';
import {
  EWidgetSource,
  IBuyCustomPackageRequestV4,
} from '../../../../repositories/billing-service-packages-balancer/entities/Purchase/BuyCustomPackageRequestV4';
import { EBuyPackageSource, IRecommendedPackageService } from '../../../../types/reducers/recommendedPackages';
import { mapItem } from './mapItem';

interface IParams {
  services: Array<IRecommendedPackageService>;
  durationInDays: number;
  startDate: string;
  polygonIds: Array<number>;
  categoriesIds: Array<number> | null;
  autoProlong: boolean;
  widgetSource: EBuyPackageSource | undefined;
}

export const getParameters = (params: IParams): IBuyCustomPackageRequestV4 => {
  const { services, durationInDays, startDate, polygonIds, categoriesIds, autoProlong, widgetSource } = params;

  return {
    items: services.map(mapItem),
    activationDate: lightFormat(parse(startDate, 'dd.MM.yyyy', new Date()), 'yyyy-MM-dd'),
    durationInDays,
    polygonIds,
    categoryIds: categoriesIds!,
    autoProlong,
    needHold: false,
    widgetSource: widgetSource as string as EWidgetSource,
  };
};
